import { OrderStatusType, PaymentMethodType } from "./types";

const statusLabelMap: Record<OrderStatusType, string> = {
  [OrderStatusType.PENDING]: "order.status.pending",
  [OrderStatusType.WAITING_FOR_ADMIN]: "order.status.waitingForAdmin",
  [OrderStatusType.PROCESSING]: "order.status.processing",
  [OrderStatusType.SUCCESS]: "order.status.success",
  [OrderStatusType.CANCELLED]: "order.status.cancelled",
  [OrderStatusType.FAILED]: "order.status.failed",
  [OrderStatusType.ACCEPTED]: "order.status.accepted",
  [OrderStatusType.REJECTED]: "order.status.rejected",
  [OrderStatusType.HOLD]: "order.status.hold",
  [OrderStatusType.SHIPPED]: "order.status.shipped",
  [OrderStatusType.DELIVERED]: "order.status.delivered",
  [OrderStatusType.QUEUED_FOR_UN_HOLD]: "order.status.queuedForUnHold",
  [OrderStatusType.NULL]: "order.status.null",
  [OrderStatusType.READY_FOR_STORE_PICKUP]: "order.status.readyForStorePickup",
};

const paymentMethodLabelMap: Record<PaymentMethodType, string> = {
  [PaymentMethodType.CASH_ON_DELIVERY]: "order.paymentType.cashOnDelivery",
  [PaymentMethodType.INVOICE]: "order.paymentType.invoice",
  [PaymentMethodType.STORE_PAYMENT]: "order.paymentType.storePayment",
  [PaymentMethodType.STRIPE]: "order.paymentType.stripe",
};

const statusColorMap: Record<OrderStatusType, string> = {
  [OrderStatusType.PENDING]: "gray",
  [OrderStatusType.WAITING_FOR_ADMIN]: "orange",
  [OrderStatusType.PROCESSING]: "blue",
  [OrderStatusType.SUCCESS]: "green",
  [OrderStatusType.CANCELLED]: "red",
  [OrderStatusType.FAILED]: "red",
  [OrderStatusType.ACCEPTED]: "green",
  [OrderStatusType.REJECTED]: "red",
  [OrderStatusType.HOLD]: "yellow",
  [OrderStatusType.SHIPPED]: "blue",
  [OrderStatusType.DELIVERED]: "green",
  [OrderStatusType.QUEUED_FOR_UN_HOLD]: "purple",
  [OrderStatusType.NULL]: "gray",
  [OrderStatusType.READY_FOR_STORE_PICKUP]: "blue",
};
const StatusData = [
  { _id: OrderStatusType.NULL, value: "order.status.null" },
  { _id: OrderStatusType.PENDING, value: "order.status.pending" },
  {
    _id: OrderStatusType.WAITING_FOR_ADMIN,
    value: "order.status.waitingForAdmin",
  },
  { _id: OrderStatusType.PROCESSING, value: "order.status.processing" },
  { _id: OrderStatusType.SUCCESS, value: "order.status.success" },
  { _id: OrderStatusType.CANCELLED, value: "order.status.cancelled" },
  { _id: OrderStatusType.FAILED, value: "order.status.failed" },
  { _id: OrderStatusType.ACCEPTED, value: "order.status.accepted" },
  { _id: OrderStatusType.REJECTED, value: "order.status.rejected" },
  { _id: OrderStatusType.HOLD, value: "order.status.hold" },
  { _id: OrderStatusType.SHIPPED, value: "order.status.shipped" },
  { _id: OrderStatusType.DELIVERED, value: "order.status.delivered" },
  {
    _id: OrderStatusType.QUEUED_FOR_UN_HOLD,
    value: "order.status.queuedForUnHold",
  },
  {
    _id: OrderStatusType.READY_FOR_STORE_PICKUP,
    value: "order.status.readyForStorePickup",
  },
];
const statusMap = {
  [OrderStatusType.PENDING]: "order.status.pending",
  [OrderStatusType.WAITING_FOR_ADMIN]: "order.status.waitingForAdmin",
  [OrderStatusType.PROCESSING]: "order.status.processing",
  [OrderStatusType.SUCCESS]: "order.status.success",
  [OrderStatusType.CANCELLED]: "order.status.cancelled",
  [OrderStatusType.FAILED]: "order.status.failed",
  [OrderStatusType.ACCEPTED]: "order.status.accepted",
  [OrderStatusType.REJECTED]: "order.status.rejected",
  [OrderStatusType.HOLD]: "order.status.hold",
  [OrderStatusType.SHIPPED]: "order.status.shipped",
  [OrderStatusType.DELIVERED]: "order.status.delivered",
  [OrderStatusType.QUEUED_FOR_UN_HOLD]: "order.status.queuedForUnHold",
  [OrderStatusType.NULL]: "order.status.null",
  [OrderStatusType.READY_FOR_STORE_PICKUP]: "order.status.readyForStorePickup",
};

const paymentMethodColorMap: Record<PaymentMethodType, string> = {
  [PaymentMethodType.CASH_ON_DELIVERY]: "gray",
  [PaymentMethodType.INVOICE]: "orange",
  [PaymentMethodType.STORE_PAYMENT]: "blue",
  [PaymentMethodType.STRIPE]: "green",
};

export {
  statusColorMap,
  statusLabelMap,
  StatusData,
  statusMap,
  paymentMethodLabelMap,
  paymentMethodColorMap,
};
